<template>
  <Sheet>
    <template #leading>
      <Sheet.Button
        :icon="hasBack ? ChevronLeftIcon : CloseIcon"
        @click="hasBack ? checker.back() : close()"
      />
    </template>
    <template #title>{{ title }}</template>

    <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
      <CheckerBody variant="sheet" />
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { ChevronLeftIcon, CloseIcon } from '@dacr/icons'

import CheckerBody from './CheckerBody.vue'
import { provideChecker } from './useChecker'

const { close } = useSheet()
const checker = provideChecker()

const hasBack = computed(
  () => checker.step.value !== 'capture' && checker.step.value !== 'empty'
)

const title = computed(() =>
  checker.step.value === 'confirm' ? 'Create report' : checker.title.value
)
</script>
